import axios from "axios";
import { servicelist, URL_API } from "../Config";

export const loginService = async (body, accessToken) => {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post(URL_API(`${servicelist.AuthService}p_auth_login_logout`), body, { headers: { pmsToken: accessToken.token } }).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const changePasswordService = async (body, accessToken) => {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post(URL_API(`${servicelist.AuthService}p_auth_change_password`), body, { headers: { pmsToken: accessToken.token } }).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
